import React from 'react';
import moment from 'moment-timezone';
import { Button } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';

import { DATE_MONTHLY_FORMAT } from '../../constants/date';

const CustomCalendarToolbar = ({ toolbar, extraRender }) => {
  const goToBack = () => toolbar.onNavigate('PREV');
  const goToNext = () => toolbar.onNavigate('NEXT');
  const goToCurrent = () => toolbar.onNavigate('TODAY');

  return (
    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <Button icon={<LeftOutlined />} onClick={goToBack} />
        <Button onClick={goToCurrent}>Today</Button>
        <Button icon={<RightOutlined />} onClick={goToNext} />
      </div>
      <div>
        <h3>{moment(toolbar.date).format(DATE_MONTHLY_FORMAT)}</h3>
      </div>
      {extraRender && extraRender()}
    </div>
  );
};

export default CustomCalendarToolbar;
